export const FETCH_CHANNEL_CONNECTIONS = 'FETCH_CHANNEL_CONNECTIONS'
export const FETCH_CHANNEL_CONNECTIONS_SUCCESS = `${FETCH_CHANNEL_CONNECTIONS}_SUCCESS`
export const DELETE_CHANNEL_CONNECTION = 'DELETE_CHANNEL_CONNECTION'
export const CREATE_CHANNEL_CONNECTION = 'CREATE_CHANNEL_CONNECTION'
export const CREATE_CHANNEL_CONNECTION_SUCCESS = `${CREATE_CHANNEL_CONNECTION}_SUCCESS`
export const UPDATE_CHANNEL_CONNECTION = 'UPDATE_CHANNEL_CONNECTION'
export const UPDATE_CHANNEL_CONNECTION_SUCCESS = `${UPDATE_CHANNEL_CONNECTION}_SUCCESS`

export const CLEAR_CURRENT_CHANNEL_CONNECTION = 'CLEAR_CURRENT_CHANNEL_CONNECTION'
export const SET_CURRENT_CHANNEL_CONNECTION = 'SET_CURRENT_CHANNEL_CONNECTION'
